import React, { useEffect, useMemo, useState } from 'react';
import { BodyM, HeadingSBold } from 'components/Typography/Typography';
import Button from 'components/CustomButtons/Button';
import Validator from 'card-validator';
import styles from 'assets/jss/material-dashboard-pro-react/components/paymentFormStyle';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import { IPaymentToken } from 'utils/api/models/payments/paymentTokens';
import Mastercard from 'assets/img/cards/mastercard.svg';
import Visa from 'assets/img/cards/visa.svg';
import americanExpress from 'assets/img/cards/american_express.svg';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CardsDialog from './CardsDialog';
import _ from 'lodash';

//@ts-ignore
const useStyles = makeStyles(styles);

interface ICardsProps {
	tokens: IPaymentToken[];
	formData: types.topUpAddOns.IFormData;
	setTokenData: (token: IPaymentToken) => void;
	setFormData: types.topUpAddOns.setFormData;
	setSaveCard: (saveCard: boolean) => void;
	validation: types.topUpAddOns.IValidation;
	setValidation: React.Dispatch<React.SetStateAction<types.topUpAddOns.IValidation>>;
}

const Cards = (props: ICardsProps) => {
	const classes = useStyles();
	const [dialog, setDialog] = useState<boolean>(false);

	const { formData, setTokenData, setFormData, setSaveCard, validation, setValidation } = props;
	const cardNumber = formData.number.slice(-4);

	const cardImage = useMemo(() => {
		const number = Validator.number(formData.number.slice(0, 4));
		switch (number.card?.type?.toUpperCase()) {
			case 'MASTERCARD':
				return Mastercard;

			case 'AMERICAN-EXPRESS':
				return americanExpress;

			case 'VISA':
			default:
				return Visa;
		}
	}, [formData.number]);

	useEffect(() => {
		setValidation((validation) => ({
			...validation,
			date: Validator.expirationDate(formData.date),
		}));
	}, [formData.date, setValidation]);

	useEffect(() => {
		setValidation((validation) => ({
			...validation,
			number: Validator.number(formData.number),
		}));
	}, [formData.number, setValidation]);

	useEffect(() => {
		setValidation((validation) => ({
			...validation,
			cvv: Validator.cvv(formData.cvv, _.get(validation.number, 'card.code.size', 3)),
		}));
	}, [validation.number, formData.cvv, setValidation]);

	return (
		<>
			<ConditionalRender
				show={dialog}
				onTrue={() => (
					<CardsDialog
						setTokenData={setTokenData}
						setFormData={setFormData}
						setSaveCard={setSaveCard}
						tokens={props.tokens}
						hideDialog={() => setDialog(false)}
						formData={formData}
					/>
				)}
			/>
			<div className={classes.cardContainer}>
				<span className={classes.cardData}>
					<span className={classes.paymentCard}>
						<BodyM inline color="secondary-light" disableMargin>
							{translate('payments.paymentCard')}
						</BodyM>
					</span>
					<span>
						<HeadingSBold inline color="secondary-light" disableMargin>
							{`•••• ${cardNumber}`}
						</HeadingSBold>
					</span>
					<span>{<img className={classes.cardIcon} src={cardImage} alt="card" />}</span>
				</span>
				<Button color="tertiary-light" onClick={() => setDialog(true)}>
					{translate('change')}
				</Button>
			</div>
		</>
	);
};

export default Cards;
